var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75,7.754H19.5v-1.6h-1.75V4.25H6.25v1.904H4.5v1.6H1.25v10.5h5v1.496h11.5v-1.496h5V7.754z M18,7.654v0.1h-0.25v-0.1H18 z M7.75,5.75h8.5v2.003h-8.5V5.75z M6,7.654h0.25v0.1H6V7.654z M16.25,18.25h-8.5v-4.5h8.5V18.25z M21.25,16.754h-3.5V13.75h1v-1.5 h-1H6.25h-1v1.5h1v3.004h-3.5v-7.5H4.5h15h1.75V16.754z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.542,
    y: 14.464,
    width: 6.917,
    height: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.542,
    y: 16.187,
    width: 4.991,
    height: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.955d087b.svg";
export { ForwardRef as ReactComponent };